import { SettlementSchema } from "@redotech/redo-model/draft-return/draft-return";
import { SubmitDraftReturnResultSchema } from "@redotech/redo-model/draft-return/submit-draft-return";
import { ChannelZod } from "@redotech/redo-model/return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const submitDraftReturn = {
  name: "submitDraftReturn" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    isRejected: z.boolean().nullish(),
    settlement: SettlementSchema.nullish(),
    paymentToken: z.string().nullish(),
    channel: ChannelZod.optional(),
  }),
  output: SubmitDraftReturnResultSchema,
};
